export default __webpack_public_path__ + "static/media/icon-success.c8ccb329.svg";